<div class="d-flex flex-column align-items-center">
    <div class="card mt-5 col-md-6 p-4 p-gutter flex-auto">
        <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
        </div>
        <h5>Generate SEB Config</h5>
        <form class="d-flex flex-column align-items-center">
            <div class="d-flex flex-column mb-3 col-md-12">
                <label class="form-label">Prohibited Processes</label>
                <div class="d-flex">
                    <textarea class="form-control" [(ngModel)]="SEBConfig.prohibitedProcesses"
                        name="prohibitedProcesses"></textarea>
                </div>
            </div>
            <div class="d-flex flex-column mb-3 col-md-12">
                <label class="form-label">Permtited Processes</label>
                <div class="d-flex">
                    <textarea class="form-control" [(ngModel)]="SEBConfig.permittedProcesses"
                        name="prohibitedProcesses"></textarea>
                </div>
            </div>
            <div class="d-flex flex-column mb-3 col-md-12">
                <label class="form-label">Max No Of Displays</label>
                <div class="d-flex">
                    <input class="form-control" type="number" min="0" [(ngModel)]="SEBConfig.maxNoOfDisplays"
                        name="maxNoOfDisplays">
                </div>

            </div>
            <div class="mb-3 col-md-12 d-flex justify-between">
                <button class="btn btn-danger" (click)="close()" name="cancelBtn">Cancel</button>
                <button class="btn btn-primary" (click)="generateConfig()" name="generateBtn">Generate</button>
            </div>
        </form>
    </div>
</div>